import { DatePicker } from '@yes.technology/react-toolkit'

type ActivityInputDateProps = {
  minimumYear?: string
  maximumYear?: string
  isFetchingBlueprints?: boolean
  helpText?: string
  explanationText?: string
} & Pick<
  React.ComponentProps<typeof DatePicker>,
  | 'id'
  | 'statusClass'
  | 'value'
  | 'format'
  | 'required'
  | 'onChange'
  | 'label'
  | 'disabled'
  | 'minFromNow'
  | 'maxFromNow'
  | 'informational'
>

const ActivityInputDate = ({
  minimumYear,
  maximumYear,
  ...props
}: ActivityInputDateProps) => {
  const currentYear = new Date().getFullYear()
  const defaultMinYear = currentYear - 100
  const defaultMaxYear = currentYear + 100

  const intMinYear = minimumYear ? parseInt(minimumYear) : defaultMinYear
  const intMaxYear = maximumYear ? parseInt(maximumYear) : defaultMaxYear

  return (
    <DatePicker
      {...props}
      isLoadingBlueprints={props.isFetchingBlueprints}
      heightClass='regular'
      minimumYear={intMinYear}
      maximumYear={intMaxYear}
      minFromNow={props.minFromNow}
      maxFromNow={props.maxFromNow}
      value={props.value || ''}
    />
  )
}

export default ActivityInputDate
